<template>
    <v-app>
        <portal-sysbar :show-customer="false"></portal-sysbar>
        <div class="main-content">
            <portal-aside></portal-aside>
            <portal-title :title="$t('message.aside.config', { value: 'default' })">
            </portal-title>
            <portal-breadcumb></portal-breadcumb>

            <div class="content"></div>
            <v-row class="d-flex justify-center mb-7">

                <v-hover v-slot="{ hover }">
                    <v-card :elevation="hover ? 16 : 2" class="homeboxes text-center ml-4 mr-4 mb-1" shapped
                        :loading="loading">
                        <v-card-text>
                            <div class="quote-card">
                                <div class="quote-card-text">
                                    <h1>Customers</h1>
                                </div>
                            </div>
                            <v-sheet>
                                <v-row class="d-flex justify-center mt-7">
                                    <v-icon x-large>mdi-face-agent</v-icon>
                                </v-row>
                            </v-sheet>
                        </v-card-text>
                    </v-card>
                </v-hover>
                <v-hover v-slot="{ hover }">
                    <v-card :elevation="hover ? 16 : 2" class="homeboxes text-center ml-4 mr-4 mb-1" :loading="loading"
                        @click="toUsers">
                        <v-card-text>
                            <div class="quote-card">
                                <div class="quote-card-text">
                                    <h1>Users</h1>
                                </div>
                            </div>
                            <v-sheet>
                                <v-row class="d-flex justify-center mt-7">
                                    <v-icon x-large>mdi-account-multiple-outline</v-icon>
                                </v-row>
                            </v-sheet>
                        </v-card-text>
                    </v-card>
                </v-hover>
                <v-hover v-slot="{ hover }">
                    <v-card :elevation="hover ? 16 : 2" class="homeboxes text-center ml-4 mr-4 mb-1" :loading="loading">
                        <v-card-text>
                            <div class="quote-card">
                                <div class="quote-card-text">
                                    <h1>Locomotives</h1>
                                </div>
                            </div>
                            <v-sheet>
                                <v-row class="d-flex justify-center mt-7">
                                    <v-icon x-large> mdi-train</v-icon>
                                </v-row>
                            </v-sheet>
                        </v-card-text>
                    </v-card>
                </v-hover>
                <v-hover v-slot="{ hover }">
                    <v-card :elevation="hover ? 16 : 2" class="homeboxes text-center ml-4 mr-4 mb-1" :loading="loading">
                        <v-card-text>
                            <div class="quote-card-text">
                                <h1>Agreements</h1>
                            </div>

                            <div class="d-flex justify-center mt-7" style="height: 30px">
                                <v-icon x-large> mdi-file-document-multiple-outline</v-icon>
                            </div>

                        </v-card-text>
                    </v-card>
                </v-hover>
                <v-hover v-slot="{ hover }">
                    <v-card :elevation="hover ? 16 : 2" class="homeboxes text-center ml-4 mr-4 mb-1">
                        <v-card-text>
                            <div class="quote-card-text">
                                <h1>Assignements</h1>
                            </div>

                            <div class="d-flex justify-center mt-7" style="height: 30px">
                                <v-icon x-large> mdi-book-multiple-outline</v-icon>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-hover>
                <v-hover v-slot="{ hover }">
                    <v-card :elevation="hover ? 16 : 2" class="homeboxes text-center ml-4 mr-4 mb-1"
                        @click="toNotification">
                        <v-card-text>
                            <div class="quote-card-text">
                                <h1>Notifications</h1>
                            </div>

                            <div class="d-flex justify-center mt-7" style="height: 30px">
                                <v-icon x-large> mdi-bell</v-icon>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </v-row>

        </div>
    </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";


export default {
    title: "Administration",
    components: {
        PortalSysbar,
        PortalAside,
        PortalTitle,
        PortalBreadcumb,
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        toUsers() {
            this.$router.push("/config/users")
        },
        toNotification() {
            this.$router.push("/config/notification")
        }
    }
}
</script>

<style scoped>
.homeboxes {
    height: 240px;
    align-content: center;
    width: 400px;
    color: "#00475A";
    padding: 10px 5px 10px 5px;
    margin-top: 2%;
    background-size: cover;
}


.value {
    color: #7fc7b2;
    font-size: 45px;
    font-weight: bolder;
    display: block;
    bottom: 5px;
}

.quote-card {
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.quote-card>h2,
.quote-card>h1 {
    color: #a0d5c5;
}

.quote-card-text>h1 {
    font-size: 50px;

}

.quote-card>h1 {
    font-size: 50px;
}
</style>